import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { RenderedService } from "../../rendered.service";
import { ActivatedRoute } from "@angular/router";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { ViewModalComponent } from "@scaffold/dialogs/view-modal/view-modal.component";
import { NbDialogService, NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "scaffold-item-link",
  templateUrl: "./item-link.component.html",
  styleUrls: ["../../rendered.component.scss", "./item-link.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemLinkComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  @Input() item;
  @Input() data;
  public destroy$: Subject<boolean> = new Subject<boolean>();
  dialogRef: NbDialogRef<ViewModalComponent>;

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private route: ActivatedRoute,
    public dialog: NbDialogService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  openLink(event) {
    this.renderedService.openLinkHandler(
      event,
      { type: this.item.item_type.value, id: this.item.item_id.value },
      this.route,
      "item_link"
    );
  }

  // TODO - hotfix This is duplicated from link.component.ts and should be in a service
  openViewLink(event: Event, item: any, mode: any, target) {
    event.preventDefault();
    //for module items
    if (target && target === "child" && item.rootItem) {
      this.openViewHandler(mode, {
        type: item.reference_type,
        id: item.reference_id,
      });
    } else {
      this.openViewHandler(mode, item);
    }
  }

  openViewHandler(mode: any, item: any) {
    let settings: any = {
      context: {
        data: {
          mode: mode,
          item: item || this.info.children || this.info,
          //   parent: parent || this.info
        },
      },
    };
    this.dialogRef = this.dialog.open(ViewModalComponent, settings);
    this.dialogRef.onClose.subscribe((result) => {
      console.log(result);
      console.log(this.item);
      console.log(this.info);
      if (result && (result !== "string" || result.length > 0)) {
        if (this.item && this.item.list_view) {
        }
      }
    });
  }
}
